<template>
  <v-flex class="icon" :class="additionalClass">
    <v-icon v-if="mimeType" :color="mimeType.color">
      {{mimeType.icon}}
    </v-icon>
  </v-flex>
</template>

<script>
export default {
  name: 'file-icon',
  props: ['mimeType', 'additionalClass'],
};
</script>

<style scoped>
  .icon {
    width: 45px;
  }
</style>
